export default "__VITE_ASSET__DSob_qTF__"